var copyButtonList = document.querySelectorAll(".dtc-clipboard-button");
var textToCopy = "BLITZ10"; // Change this when coupon changes

copyButtonList.forEach((copyButton) => {
    // Get child copy button
    const toast = copyButton.querySelector('.dtc-clipboard-coupon');
    copyButton.addEventListener('click', () => {
        navigator.clipboard.writeText(textToCopy)
        .then(() => {
            if (toast) {
                toast.innerText = textToCopy + " copied!";
            }
        })
    })
})